exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onlineUsers {\n  padding: 20px 5px;\n  background: #182d35;\n  color: #fff;\n  font-size: 14px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  -ms-flex-align: center;\n      align-items: center;\n  border: 5px solid #3e5764;\n  margin: 10px 10px 10px;\n  box-shadow: 0px 3px 5px #212c32;\n  border-radius: 7px;\n  direction: initial;\n  cursor: pointer; }\n  .onlineUsers .title {\n    color: #14dc36; }\n  .onlineUsers .count {\n    font-size: 16px;\n    font-weight: bolder;\n    color: #fff; }\n\n.table-responsive {\n  max-height: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/OnlineUsers/OnlineUsers.component.scss
// module id = ../../../../../app/shared/components/OnlineUsers/OnlineUsers.component.scss
// module chunks = main